import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffdae48d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tpd-content-layout" }
const _hoisted_2 = { class: "tp-dashboard-tab mb-30" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "tp-dashboard-tab-title border-0 m-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "|", -1 /* HOISTED */))
const _hoisted_6 = { class: "text-secondary" }
const _hoisted_7 = {
  key: 0,
  class: "ms-auto me-3"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "tp-dashboard-tab-title border-0 m-0" }
const _hoisted_11 = {
  key: 0,
  class: "ms-auto me-3"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync-alt" }, null, -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1 /* HOISTED */))
const _hoisted_15 = { class: "tpd-table mb-25" }
const _hoisted_16 = {
  key: 0,
  class: "table table-sm table-hover table-bordered tickets-table"
}
const _hoisted_17 = {
  style: {"width":"150px"},
  scope: "col"
}
const _hoisted_18 = { scope: "col" }
const _hoisted_19 = {
  style: {"width":"150px"},
  scope: "col"
}
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"80px"},
  scope: "col"
}, null, -1 /* HOISTED */))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "text-primary" }
const _hoisted_24 = {
  class: "text-dark font-s-13",
  style: {"line-height":"18px"}
}
const _hoisted_25 = { class: "font-s-13" }
const _hoisted_26 = ["data-status"]
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = ["tooltip"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock me-1" }, null, -1 /* HOISTED */))
const _hoisted_30 = {
  key: 0,
  colspan: "5",
  class: "text-center"
}
const _hoisted_31 = {
  class: "spinner-border mt-2",
  role: "status"
}
const _hoisted_32 = { class: "sr-only" }
const _hoisted_33 = {
  key: 0,
  colspan: "5",
  class: "text-center"
}
const _hoisted_34 = {
  key: 0,
  class: "text-center"
}
const _hoisted_35 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_36 = { class: "sr-only" }
const _hoisted_37 = { class: "mb-3 d-flex align-items-center" }
const _hoisted_38 = ["data-status"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_40 = { class: "d-flex align-items-center gap-3" }
const _hoisted_41 = { class: "font-s-13" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-folder me-1" }, null, -1 /* HOISTED */))
const _hoisted_43 = { class: "font-s-13" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-folder-open me-1" }, null, -1 /* HOISTED */))
const _hoisted_45 = ["tooltip"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock me-1" }, null, -1 /* HOISTED */))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_51 = ["href"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file me-1" }, null, -1 /* HOISTED */))
const _hoisted_53 = { class: "mt-4" }
const _hoisted_54 = { class: "card m-0" }
const _hoisted_55 = { class: "card-header d-flex align-items-center" }
const _hoisted_56 = { class: "m-0" }
const _hoisted_57 = { class: "ms-auto" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-reply me-1" }, null, -1 /* HOISTED */))
const _hoisted_59 = {
  key: 0,
  class: "text-center pt-3"
}
const _hoisted_60 = { class: "card-body pb-1" }
const _hoisted_61 = {
  class: "card p-3 mb-3 animate__animated",
  style: {"background":"#fafafa"}
}
const _hoisted_62 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_63 = { class: "user d-flex flex-row align-items-center" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "font-weight-bold text-primary" }
const _hoisted_66 = ["tooltip"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-clock me-1" }, null, -1 /* HOISTED */))
const _hoisted_68 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" dashboard-content-area-start "),
    _createElementVNode("div", _hoisted_1, [
      _createCommentVNode(" dashboard-tab-area "),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($data.show_details)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h2", _hoisted_4, [
                  _createElementVNode("a", {
                    class: "pointer-event",
                    onClick: _cache[0] || (_cache[0] = $event => ($data.show_details=false))
                  }, _toDisplayString($setup.lms_website.__('My Tickets')), 1 /* TEXT */),
                  _hoisted_5,
                  _createElementVNode("small", _hoisted_6, _toDisplayString($data.tickets.details?.name), 1 /* TEXT */)
                ]),
                ($options.isStudent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = $event => ($options.refreshTicket($data.tickets.details?.name))),
                        class: "btn btn-sm btn-outline-secondary"
                      }, _hoisted_9)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("h2", _hoisted_10, _toDisplayString($setup.lms_website.__('My Tickets')), 1 /* TEXT */),
                ($options.isStudent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = (...args) => ($options.refreshTickets && $options.refreshTickets(...args))),
                        class: "btn btn-sm btn-outline-secondary me-2"
                      }, _hoisted_13),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = (...args) => ($options.newTicket && $options.newTicket(...args))),
                        class: "btn btn-sm btn-primary"
                      }, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString($setup.lms_website.__('New Ticket')), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
        ])
      ]),
      _createCommentVNode(" dashboard-tab-area-end "),
      _createElementVNode("div", _hoisted_15, [
        (!$data.show_details)
          ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_17, _toDisplayString($setup.lms_website.__('Ticket ID')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_18, _toDisplayString($setup.lms_website.__('Ticket Subject')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_19, _toDisplayString($setup.lms_website.__('Type')), 1 /* TEXT */),
                  _createElementVNode("th", _hoisted_20, _toDisplayString($setup.lms_website.__('Status')), 1 /* TEXT */),
                  _hoisted_21
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!$data.tickets.loading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.paginatedTickets, (row) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "pointer-event",
                        onClick: $event => ($options.openTicket(row.name)),
                        key: row.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("a", _hoisted_23, _toDisplayString(row.name), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("a", _hoisted_24, _toDisplayString(row.subject), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(row.ticket_type), 1 /* TEXT */)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: "badge text-bg-secondary",
                            "data-status": row.workflow_state
                          }, _toDisplayString($setup.lms_website.__(row.custom_request_type)), 9 /* TEXT, PROPS */, _hoisted_26)
                        ]),
                        _createElementVNode("td", _hoisted_27, [
                          _createElementVNode("span", {
                            class: "d-inline-block",
                            tooltip: $setup.moment(row.creation).format('YYYY-MM-DD (HH:mm) A')
                          }, [
                            _hoisted_29,
                            _createTextVNode(" " + _toDisplayString($setup.frappe.datetime.prettyDate(row.creation, true)), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_28)
                        ])
                      ], 8 /* PROPS */, _hoisted_22))
                    }), 128 /* KEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("tr", null, [
                  ($data.tickets.loading)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString($setup.lms_website.__('Loading')), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("tr", null, [
                  (!$data.tickets.loading && !$data.tickets.list.length)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString($setup.lms_website.__('No tickets found')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($data.show_details)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              ($data.show_details_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString($setup.lms_website.__('Loading')), 1 /* TEXT */)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("h5", _hoisted_37, [
                      _createTextVNode(_toDisplayString($data.tickets.details?.subject) + " ", 1 /* TEXT */),
                      _createElementVNode("span", {
                        class: "badge text-bg-secondary ms-auto",
                        "data-status": $data.tickets.details?.workflow_state
                      }, _toDisplayString($setup.lms_website.__($data.tickets.details?.workflow_state)), 9 /* TEXT, PROPS */, _hoisted_38)
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, [
                        _hoisted_42,
                        _createTextVNode(" " + _toDisplayString($data.tickets.details?.custom_ticket_name), 1 /* TEXT */)
                      ]),
                      _createElementVNode("span", _hoisted_43, [
                        _hoisted_44,
                        _createTextVNode(" " + _toDisplayString($data.tickets.details?.custom_ticket_type), 1 /* TEXT */)
                      ]),
                      _createElementVNode("span", {
                        class: "font-s-13 ms-auto",
                        tooltip: $setup.moment($data.tickets.details?.creation).format('YYYY-MM-DD (HH:mm) A')
                      }, [
                        _hoisted_46,
                        _createTextVNode(" " + _toDisplayString($setup.frappe.datetime.prettyDate($data.tickets.details?.creation, true)), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_45)
                    ]),
                    _hoisted_47,
                    _createElementVNode("div", {
                      innerHTML: $data.tickets.details?.description
                    }, null, 8 /* PROPS */, _hoisted_48),
                    ($data.tickets.details?.custom_attach)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("h6", null, _toDisplayString($setup.lms_website.__('Attachments')) + ":", 1 /* TEXT */),
                          _createElementVNode("a", {
                            href: $data.tickets.details?.custom_attach,
                            class: "btn btn-sm btn-light",
                            target: "_blank"
                          }, [
                            _hoisted_52,
                            _createTextVNode(" " + _toDisplayString($options.getAttachmentFileName($data.tickets.details?.custom_attach)), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_51)
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("h5", _hoisted_56, _toDisplayString($setup.lms_website.__('Comments ({0})', [$data.tickets.details?.comments?.length])), 1 /* TEXT */),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-primary",
                              onClick: _cache[4] || (_cache[4] = (...args) => ($options.newComment && $options.newComment(...args)))
                            }, [
                              _hoisted_58,
                              _createTextVNode(" " + _toDisplayString($setup.lms_website.__('Reply')), 1 /* TEXT */)
                            ])
                          ])
                        ]),
                        (!$data.tickets.details?.comments?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString($setup.lms_website.__('No comments found')), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_60, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tickets.details?.comments, (comment) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("img", {
                                    src: comment.user_image || '/assets/lms_website/images/user.png',
                                    width: "30",
                                    class: "user-img rounded-circle mr-2"
                                  }, null, 8 /* PROPS */, _hoisted_64),
                                  _createElementVNode("span", null, [
                                    _createElementVNode("small", _hoisted_65, _toDisplayString(comment.sender), 1 /* TEXT */)
                                  ])
                                ]),
                                _createElementVNode("span", {
                                  class: "font-s-12 ms-auto",
                                  tooltip: $setup.moment(comment.creation).format('YYYY-MM-DD (HH:mm) A')
                                }, [
                                  _hoisted_67,
                                  _createTextVNode(" " + _toDisplayString($setup.frappe.datetime.prettyDate(comment.creation, true)), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_66)
                              ]),
                              _createElementVNode("div", {
                                class: "comment-content",
                                innerHTML: comment.content
                              }, null, 8 /* PROPS */, _hoisted_68)
                            ]))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      (!$data.tickets.loading && !$data.show_details)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            "current-page": $data.tickets.currentPage,
            "total-items": $data.tickets.list.length,
            "items-per-page": $data.tickets.itemsPerPage,
            onPageChanged: $options.handlePageChange
          }, null, 8 /* PROPS */, ["current-page", "total-items", "items-per-page", "onPageChanged"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" dashboard-content-area-end ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}